import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { useEffect, useState } from "react";

/**
 * Cycles the sport word in the hero headline so it reads as
 * "A free football / basketball / ... team management app".
 * Purely presentational.
 */
export const SPORTS = [
  "football",
  "basketball",
  "volleyball",
  "handball",
  "hockey",
  "rugby",
  "pickleball",
  "any sport",
];

const RotatingSport = ({ words = SPORTS, interval = 2200 }: { words?: string[]; interval?: number }) => {
  const reduce = useReducedMotion();
  const [i, setI] = useState(0);

  useEffect(() => {
    if (reduce) return;
    const id = setInterval(() => setI((n) => (n + 1) % words.length), interval);
    return () => clearInterval(id);
  }, [reduce, words.length, interval]);

  if (reduce) {
    return <span className="text-primary">{words[0]}</span>;
  }

  return (
    <span className="relative inline-grid align-bottom overflow-hidden">
      {/* Invisible sizer keeps the headline from jumping around as words swap. */}
      <span aria-hidden="true" className="col-start-1 row-start-1 invisible">
        {words.reduce((a, b) => (b.length > a.length ? b : a), "")}
      </span>
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={words[i]}
          initial={{ y: "0.9em", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "-0.9em", opacity: 0 }}
          transition={{ duration: 0.38, ease: [0.22, 1, 0.36, 1] }}
          className="col-start-1 row-start-1 text-primary whitespace-nowrap"
        >
          {words[i]}
        </motion.span>
      </AnimatePresence>
    </span>
  );
};

export default RotatingSport;
